import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import {
  addEditProductValidation,
  errorResponseMessage,
} from "../shared/const.prop";
import ErrorMessage from "../components/ErrorMessage";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import axiosHttp from "../config/axios.interceptor";
import { toast } from "react-toastify";

const AddEditProduct = ({ editData = {} }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      productName: editData?.name || "",
      type: editData?.product_offerings_type_id || "",
      url: editData?.link || "",
    },
  });

  const validateProductData = (data) => {
    const validationErrors = [];

    // Check product name
    if (!data.productName?.trim()) {
      validationErrors.push("Product name is required");
    }

    // Check product type
    if (!data.type) {
      validationErrors.push("Product type is required");
    }

    return validationErrors;
  };

  const submitHandler = async (data) => {
    // Create submission object
    const submissionData = {
      ...data,
      ...(editData?.isEdit && { _id: editData._id }),
    };
    appContext.updateModalState({
      name: "confirmAction",
      data: submissionData,
      isEdit: editData?.isEdit,
    });
    // const validationErrors = validateProductData(data);
    // try {
    //   const response = await axiosHttp.post(
    //     editData?.isEdit
    //       ? `product-offering/${editData._id}`
    //       : `product-offering`,
    //     {
    //       name: data.productName.trim(),
    //       product_offerings_type_id: data.type.toLowerCase(),
    //       link: data.url,
    //     }
    //   );
    //   if (response.status === 201) {
    //     appContext.updateModalState("fetchService");
    //   }
    // } catch (error) {
    //   if (error.response?.status === 429) {
    //     appContext.updateNotificationState({
    //       show: true,
    //       message: errorResponseMessage(error),
    //       type: "error",
    //     });
    //     authContext.logout();
    //     return;
    //   }
    //   appContext.updateNotificationState({
    //     show: true,
    //     message: errorResponseMessage(error),
    //     type: "error",
    //   });
    // }
  };

  return (
    <form className="service-card" onSubmit={handleSubmit(submitHandler)}>
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor="productName">Name</label>
            <input
              type="text"
              className="form-control"
              id="productName"
              {...register("productName", addEditProductValidation.productName)}
            />
            <ErrorMessage errors={errors} errorKey="productName" />
          </div>
        </div>
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor="type">Type</label>
            <select
              className="form-control custom-select"
              id="type"
              {...register("type", addEditProductValidation.type)}
            >
              <option value="">Select Type</option>
              {editData.categoryList &&
                editData.categoryList.map((type) => (
                  <option key={type} value={type._id}>
                    {type.name}
                  </option>
                ))}
            </select>
            <ErrorMessage errors={errors} errorKey="type" />
          </div>
        </div>
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor="url">Link</label>
            <input
              type="url"
              className="form-control"
              id="url"
              {...register("url", addEditProductValidation.url)}
            />
            <ErrorMessage errors={errors} errorKey="url" />
          </div>
        </div>
      </div>

      <button
        className="btn btn-primary btn-reel"
        type="submit"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Saving..." : editData?.isEdit ? "Save" : "Add"}
      </button>
    </form>
  );
};

export default AddEditProduct;
